module.exports = {
  "3xs": "12.5rem", // 200px
  "2xs": "15rem", // 240px
};
